import { HttpInterceptorFn } from '@angular/common/http'
import { TenantConfigService } from '@app/services/tenant.service'
import { environment } from '@env/environment'
import { inject } from '@angular/core'

export const tenantInterceptor: HttpInterceptorFn = (request, next) => {
    const tenantConfigService = inject(TenantConfigService)
    const config = tenantConfigService.config()

    if (!config) {
        return next(request)
    }

    const isApiRequest = request.url.startsWith(config.apiBaseUrl || environment.urlApi)

    if (!isApiRequest) {
        return next(request)
    }

    const tenantId = config.tenantId || environment.tenantId

    if (!tenantId) {
        return next(request)
    }

    return next(request.clone({
        setHeaders: {
            'x-tenant-id': tenantId
        }
    }))
}
